// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-color-button {
  pointer-events: none;
  font-size: 2rem;
  line-height: 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/ColorPicker/AddColorButton.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,eAAA;EACA,cAAA;AACF","sourcesContent":[".add-color-button {\n  pointer-events: none;\n  font-size: 2rem;\n  line-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
